import { MapControl } from './map_control';

import { control_types as control } from './control_types';
import { layer_types as layer } from './layer_types';
import { geocoder_types as geocoder } from './geocoder_types';
import { interaction_types as interaction } from './interaction/interaction_types';
import { style_types as style } from './style/style_types';
import { projection } from './projection';
import { extent } from './extent';
import { geometry } from './geometry';
import { feature } from './feature';
import { util_types as util } from './util_types';

const map = {
	MapControl,
	control,
	layer,
	geocoder,
	interaction,
	style,
	projection,
	extent,
	geometry,
	feature, 
	util
}

export {
	map
}
